import { shallowEqual } from 'react-redux';
import { connectMediaStore, useMMSelector } from './withOwnReduxStore';
import {
  getAllowedDeviationTypes,
  getAllowedDeviationResourceTypes,
  getAllowGifs,
  getAllowPremium,
  getAllowMature,
  getIgnoreDeviationIds,
  getMinDeviationWidth,
  getMinDeviationHeight,
  getAllowInTierContent,
  getAllowDefaultImage,
} from '../selectors';
import { DeviationResourceType, DeviationTypes } from '../../types/deviation';

export type WithFilterProps = {
  allowedDeviationTypes?: DeviationTypes[];
  allowedDeviationResourceTypes?: DeviationResourceType[];
  allowGifs?: boolean;
  allowPremium?: boolean;
  allowInTierContent?: boolean;
  allowMature?: boolean;
  allowDefaultImage?: boolean;
  ignoreDeviationIds?: number[];
  minDeviationWidth?: number;
  minDeviationHeight?: number;
  minFileSize?: number;
  maxFileSize?: number;
};

const mapStateToProps = state => ({
  allowedDeviationTypes: getAllowedDeviationTypes(state),
  allowedDeviationResourceTypes: getAllowedDeviationResourceTypes(state),
  allowGifs: getAllowGifs(state),
  allowPremium: getAllowPremium(state),
  allowInTierContent: getAllowInTierContent(state),
  allowMature: getAllowMature(state),
  allowDefaultImage: getAllowDefaultImage(state),
  ignoreDeviationIds: getIgnoreDeviationIds(state),
  minDeviationWidth: getMinDeviationWidth(state),
  minDeviationHeight: getMinDeviationHeight(state),
});

export const useFilterProps = (): WithFilterProps => ({
  ...useMMSelector(mapStateToProps, shallowEqual),
});

export default connectMediaStore(mapStateToProps);
